(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-ad-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.bmLandingEventsBound) return;
  window.bmLandingEventsBound = true;
document.addEventListener('change', event => {
  if (!event.target.matches('[data-bml-variant]')) return;
  const option = event.target;
  const form = option.closest('form');
  form.querySelector('[data-bml-price]').textContent = option.dataset.price;
  const section = form.closest('.bml');
  if (form.getAttribute('id') !== section.dataset.bmlMainForm) return;
  section.querySelectorAll('[data-bml-selected-price]').forEach(node => { node.textContent = option.dataset.price; });
  section.querySelectorAll('[data-bml-selected-title]').forEach(node => { if (option.dataset.name) node.textContent = option.dataset.name; });
  section.querySelectorAll('[data-bml-selected-name]').forEach(node => { node.textContent = option.dataset.name ? option.dataset.name + ' · ' : ''; });
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('.bml-buy form')) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button.disabled) return;
  const error = form.querySelector('[data-bml-error]');
  const fallbackError = error.textContent;
  error.hidden = true;
  const buttons = [button, ...document.querySelectorAll('button[form="' + form.getAttribute('id') + '"]')];
  buttons.forEach(control => { control.disabled = true; });
  button.setAttribute('aria-busy', 'true');
  drawer.setActiveElement(button);
  let added = false;
  try {
    const data = new FormData(form);
    data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.append('sections_url', window.location.pathname);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || fallbackError);
    added = true;
    drawer.renderContents(state);
  } catch (failure) {
    if (added) {
      // Never retry an accepted add: a rendering failure must not duplicate it.
      window.location.assign(window.Shopify.routes.root + 'cart');
      return;
    }
    error.textContent = failure.message || fallbackError;
    error.hidden = false;
  } finally {
    buttons.forEach(control => { control.disabled = false; });
    button.removeAttribute('aria-busy');
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-style-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.bmLandingEventsBound) return;
  window.bmLandingEventsBound = true;

document.addEventListener('change', event => {
  if (!event.target.matches('[data-bml-variant]')) return;
  const option = event.target;
  const form = option.closest('form');
  form.querySelector('[data-bml-price]').textContent = option.dataset.price;
  const section = form.closest('.bml');
  if (form.getAttribute('id') !== section.dataset.bmlMainForm) return;
  section.querySelectorAll('[data-bml-selected-price]').forEach(node => { node.textContent = option.dataset.price; });
  section.querySelectorAll('[data-bml-selected-title]').forEach(node => { if (option.dataset.name) node.textContent = option.dataset.name; });
  section.querySelectorAll('[data-bml-selected-name]').forEach(node => { node.textContent = option.dataset.name ? option.dataset.name + ' · ' : ''; });
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('.bml-buy form')) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.renderContents !== 'function') return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button.disabled) return;
  const error = form.querySelector('[data-bml-error]');
  const fallbackError = error.textContent;
  error.hidden = true;
  const buttons = [button, ...document.querySelectorAll('button[form="' + form.getAttribute('id') + '"]')];
  buttons.forEach(control => { control.disabled = true; });
  button.setAttribute('aria-busy', 'true');
  drawer.setActiveElement(button);
  let added = false;
  try {
    const data = new FormData(form);
    data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.append('sections_url', window.location.pathname);
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || fallbackError);
    added = true;
    drawer.renderContents(state);
  } catch (failure) {
    if (added) {
      // Never retry an accepted add: a rendering failure must not duplicate it.
      window.location.assign(window.Shopify.routes.root + 'cart');
      return;
    }
    error.textContent = failure.message || fallbackError;
    error.hidden = false;
  } finally {
    buttons.forEach(control => { control.disabled = false; });
    button.removeAttribute('aria-busy');
  }
});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-finish"] && !Shopify.designMode) return;
  try {
    
function initBlackMaskFinish(root) {
  root.querySelectorAll('.bm-finish').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    section.addEventListener('click', event => {
      const button = event.target.closest('[data-bm-filter]');
      if (!button) return;
      const filter = button.dataset.bmFilter;
      const update = () => {
        section.querySelectorAll('[data-bm-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelectorAll('[data-bm-card]').forEach(card => card.hidden = filter !== 'all' && !card.dataset.bmFinishes.split(' ').includes(filter));
        section.querySelector('[data-bm-filter-status]').textContent = button.textContent;
      };
      if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update); else update();
    });
  });
}
initBlackMaskFinish(document);
document.addEventListener('shopify:section:load', event => initBlackMaskFinish(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
